import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class RssAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'rss';
	getDetailSourceAsync(key) {
		let request = {
			url: [this.getAPIUrl(), 'detail', key].join('/')
		};
		return httpClient.getAsync(request);
	}	
}

export default new RssAPI();